import React from 'react'
import { buildUrl } from '../../services'

const ImageComponent = ({ alt, node: { children: [node] }, width, height, src, meta, close, localData }) => {
	const id = node?.value || ""

	return <img width={width} height={height} src={buildUrl('/file', { id: src || id }, meta.scope)} alt={alt} />
}

export default ImageComponent